import {
  Button,
  DialogActions,
  Grid,
  IconButton,
  TextField,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import { useState } from "react";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { useChangePasswordMutation } from "../../../services/users/usersService";
import { Alert } from "@material-ui/lab";
import SuccessDialogBody from "../../../components/common/dialogs/SuccessDialogBody";

interface props {
  handleClose: () => void;
  refetch: () => void;
  idUser: number;
}

const ChangePasswordForm = ({ handleClose, idUser }: props) => {
  const [show, setShow] = useState(false);

  const [changePass, { isLoading, isSuccess, isError }] =
    useChangePasswordMutation();

  const schema = yup.object().shape({
    newPassword: yup.string().required("Nueva contraseña es requerida"),
    repeatNewPassword: yup
      .string()
      .oneOf(
        [yup.ref("newPassword")],
        "Contraseña no es igual a la proporcionada"
      )
      .required("Repetir Nueva contraseña es requerida"),
  });

  const { getFieldProps, errors, touched, handleSubmit } = useFormik({
    initialValues: {
      newPassword: "",
      repeatNewPassword: "",
    },
    validationSchema: schema,
    onSubmit(values) {
      changePass({
        id: idUser,
        contrasenia: values.newPassword,
      });
    },
  });

  if (isSuccess) {
    return (
      <SuccessDialogBody
        handleClose={handleClose}
        successMessage="Se cambio la contraseña correctamente."
      />
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
        <TextField
          label="Nueva Contaseña"
          fullWidth
          variant="outlined"
          {...getFieldProps("newPassword")}
          error={Boolean(errors.newPassword && touched.newPassword)}
          helperText={
            Boolean(errors.newPassword && touched.newPassword) &&
            errors.newPassword
          }
          type={show ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => setShow(!show)}>
                {!show ? <IconEye /> : <IconEyeOff />}
              </IconButton>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <TextField
          label="Repetir Nueva Contaseña"
          fullWidth
          variant="outlined"
          {...getFieldProps("repeatNewPassword")}
          error={Boolean(errors.repeatNewPassword && touched.repeatNewPassword)}
          helperText={
            Boolean(errors.repeatNewPassword && touched.repeatNewPassword) &&
            errors.repeatNewPassword
          }
          type={show ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => setShow(!show)}>
                {!show ? <IconEye /> : <IconEyeOff />}
              </IconButton>
            ),
          }}
        />
      </Grid>
      {isError && (
        <Grid item xs={12} md={12} lg={12}>
          <Alert severity="error">
            El servicio no esta disponible por el momento. Intente luego.
          </Alert>
        </Grid>
      )}
      <Grid item xs={12} md={12} lg={12}>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
            disabled={isLoading || isSuccess}
          >
            Guardar
          </Button>
        </DialogActions>
      </Grid>
    </Grid>
  );
};

export default ChangePasswordForm;
